import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/lib/business";

export default function Faq() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-20 md:py-28 bg-white"
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-12">
          <div className="flex items-center gap-3 mb-4">
            <span className="h-px w-10 bg-[#D32F2F]" />
            <span className="font-mono-label text-[#D32F2F]">Frequently Asked</span>
          </div>
          <h2 className="font-display text-3xl md:text-5xl font-bold text-[#0B132B] leading-[1.05]">
            Straight Answers,{" "}
            <span className="text-[#D32F2F]">No Runaround.</span>
          </h2>
          <p className="mt-5 text-[#4A5568] text-lg leading-relaxed">
            Here are the questions Madison Heights drivers ask most. Don't see
            yours? Call us — we're happy to help.
          </p>
        </div>

        <Accordion
          type="single"
          collapsible
          className="border-t border-[#E2E8F0]"
          data-testid="faq-accordion"
        >
          {FAQS.map((f, idx) => (
            <AccordionItem
              key={f.q}
              value={`faq-${idx}`}
              className="border-b border-[#E2E8F0]"
              data-testid={`faq-item-${idx}`}
            >
              <AccordionTrigger className="py-6 text-left hover:no-underline group">
                <div className="flex items-start gap-4 pr-4">
                  <span className="font-mono-label text-[#D32F2F] pt-1">
                    /{String(idx + 1).padStart(2, "0")}
                  </span>
                  <span className="font-display text-lg md:text-xl font-semibold text-[#0B132B] group-hover:text-[#D32F2F] transition-colors">
                    {f.q}
                  </span>
                </div>
              </AccordionTrigger>
              <AccordionContent className="pl-12 pr-4 pb-6 text-[#4A5568] text-base leading-relaxed">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
